import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {Link} from 'react-router-dom';

class Navigation extends React.Component {

    render() {

        return (
            <div className="footer">
                <div className="navigation">
                    <ul>
                        <li className={this.props.routing.location.pathname === "/ProductType" ? 'current' : (this.props.order.product_type !== null ? 'active' : '')}>
                            <Link to="/ProductType">
                                <div className="svg-container">
                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                             width="84px" height="84px" viewBox="0 0 84 84" enableBackground="new 0 0 84 84" xmlSpace="preserve">
                                        <g>
                                            <circle fill="none" cx="42.078" cy="41.756" r="41.086"/>
                                        </g>
                                        <g>
                                            <g>
                                                <path fillRule="evenodd" clipRule="evenodd" fill="#008000" d="M38.833,24.927c4.493,2.313,7.328,5.762,10.373,8.89
                                                    c0.219-0.314,0.419-0.586,0.572-0.764c0.731-0.849,1.271-0.882,1.919-1.048c0.649-0.166,1.064-0.166,1.283-0.404
                                                    c0.243-0.266,0.453-0.53,0.648-0.79c-4.545-3.958-8.694-9.284-14.511-11.484c-7.618-2.882-16.611-1.881-16.611-1.881v5.708
                                                    C22.507,23.153,33.345,22.099,38.833,24.927z M57.806,33.845c-1.064-0.592-2.08-1.315-3.073-2.111
                                                    c-0.265,0.447-0.504,0.813-0.64,0.927c-0.433,0.366-0.978,0.267-1.376,0.316c-0.4,0.05-0.987,0.174-1.569,0.822
                                                    c-0.171,0.19-0.485,0.613-0.845,1.113c1.531,1.487,3.164,2.857,5.123,3.937c6.352,3.497,16.348,2.943,16.348,2.943v-5.708
                                                    C71.773,36.084,63.82,37.184,57.806,33.845z M42.078,0.67c-22.691,0-41.087,18.395-41.087,41.086s18.396,41.087,41.087,41.087
                                                    s41.086-18.396,41.086-41.087S64.77,0.67,42.078,0.67z M42.078,79.506c-20.849,0-37.75-16.901-37.75-37.75
                                                    s16.901-37.75,37.75-37.75s37.75,16.901,37.75,37.75S62.927,79.506,42.078,79.506z M50.736,52.395
                                                    c-0.167-0.648-0.166-1.063-0.404-1.282c-0.084-0.076-0.166-0.141-0.25-0.212c-3.396,3.345-6.329,7.237-11.249,9.771
                                                    c-5.489,2.827-16.327,1.772-16.327,1.772v5.708c0,0,8.993,1.002,16.611-1.881c5.589-2.114,9.636-7.116,13.976-11.016
                                                    c-0.539-0.358-1.037-0.705-1.311-0.941C50.936,53.582,50.902,53.044,50.736,52.395z M55.426,46.749
                                                    c-1.581,0.871-2.949,1.933-4.225,3.091c0.078,0.059,0.154,0.118,0.19,0.159c0.366,0.433,0.266,0.978,0.315,1.377
                                                    c0.051,0.399,0.174,0.986,0.823,1.569c0.266,0.238,0.985,0.759,1.74,1.29c1.138-0.947,2.306-1.799,3.535-2.481
                                                    c6.015-3.34,13.968-2.24,13.968-2.24v-5.708C71.773,43.806,61.777,43.253,55.426,46.749z"/>
                                            </g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                  </svg>
                                </div>
                                SPLIT
                            </Link>
                        </li>
                        <li className={this.props.routing.location.pathname === "/ConnectorType" ? 'current' : (this.props.order.connector_type !== null ? 'active' : '')}>
                            <Link to={this.props.order.product_type !== null ? "/ConnectorType" : '#'}>
                                <div className="svg-container">
                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                         width="84px" height="84px" viewBox="0 0 84 84" enableBackground="new 0 0 84 84" xmlSpace="preserve">
                                    <g>
                                        <g>
                                            <path fillRule="evenodd" clipRule="evenodd" fill="#FC0303" d="M36.932,64.698c-1.382,0-2.503,1.12-2.503,2.503
                                                c0,1.382,1.121,2.502,2.503,2.502s2.502-1.12,2.502-2.502C39.434,65.818,38.314,64.698,36.932,64.698z M61.591,46.158V32.861
                                                c0-1.839-0.642-3.33-1.433-3.33H24.341c-0.791,0-1.433,1.491-1.433,3.33v13.297c0,1.839,0.642,3.33,1.433,3.33h35.817
                                                C60.949,49.488,61.591,47.997,61.591,46.158z M25.043,58.441c-1.382,0-2.502,1.12-2.502,2.502c0,1.383,1.12,2.503,2.502,2.503
                                                s2.503-1.12,2.503-2.503C27.546,59.562,26.426,58.441,25.043,58.441z M60.082,58.441c-1.383,0-2.503,1.12-2.503,2.502
                                                c0,1.383,1.12,2.503,2.503,2.503s2.502-1.12,2.502-2.503C62.584,59.562,61.465,58.441,60.082,58.441z M41.729,0.67
                                                c-22.691,0-41.086,18.395-41.086,41.086s18.395,41.087,41.086,41.087s41.086-18.396,41.086-41.087S64.42,0.67,41.729,0.67z
                                                 M41.729,79.506c-20.849,0-37.75-16.901-37.75-37.75s16.901-37.75,37.75-37.75s37.75,16.901,37.75,37.75
                                                S62.578,79.506,41.729,79.506z M49.445,64.698c-1.383,0-2.503,1.12-2.503,2.503c0,1.382,1.12,2.502,2.503,2.502
                                                s2.503-1.12,2.503-2.502C51.948,65.818,50.828,64.698,49.445,64.698z"/>
                                        </g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    </svg>

                                </div>
                                    CONNECTOR
                            </Link>
                        </li>
                        <li className={this.props.routing.location.pathname === "/FiberType" ? 'current' : (this.props.order.fiber_type !== null ? 'active' : '')}>
                             <Link to={this.props.order.connector_type !== null ? "/FiberType" : '#'}>
                                <div className="svg-container">
                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                         width="84px" height="84px" viewBox="0 0 84 84" enableBackground="new 0 0 84 84" xmlSpace="preserve">
                                    <g>
                                        <circle fill="none" cx="42.078" cy="41.756" r="41.086"/>
                                    </g>
                                    <g>
                                        <g>
                                            <path fillRule="evenodd" clipRule="evenodd" fill="#FF0000" d="M42.38,17.248c-13.535,0-24.507,10.972-24.507,24.507
                                                S28.845,66.262,42.38,66.262c13.536,0,24.507-10.972,24.507-24.507S55.916,17.248,42.38,17.248z M42.38,64.271
                                                c-12.436,0-22.517-10.081-22.517-22.517S29.945,19.237,42.38,19.237c12.436,0,22.517,10.082,22.517,22.518
                                                S54.816,64.271,42.38,64.271z M42.379,0.67c-22.691,0-41.086,18.395-41.086,41.086s18.395,41.087,41.086,41.087
                                                s41.087-18.396,41.087-41.087S65.07,0.67,42.379,0.67z M42.379,79.506c-20.849,0-37.75-16.901-37.75-37.75
                                                s16.901-37.75,37.75-37.75c20.849,0,37.75,16.901,37.75,37.75S63.229,79.506,42.379,79.506z M42.382,35.077
                                                c-3.688,0-6.677,2.989-6.677,6.677c0,3.687,2.989,6.677,6.677,6.677s6.677-2.99,6.677-6.677
                                                C49.059,38.066,46.069,35.077,42.382,35.077z"/>
                                        </g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    </svg>
                                </div>
                                FIBRE
                            </Link>
                        </li>
                        <li className={this.props.routing.location.pathname === "/CableType" ? 'current' : (this.props.order.cable_type !== null ? 'active' : '')}>
                            <Link to={this.props.order.fiber_type !== null ? "/CableType" : '#'}>
                                <div className="svg-container">
                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                         width="84px" height="84px" viewBox="0 0 84 84" enableBackground="new 0 0 84 84" xmlSpace="preserve">
                                    <g>
                                        <circle fill="none" cx="42.078" cy="41.756" r="41.086"/>
                                    </g>
                                    <g>
                                        <g>
                                            <path fillRule="evenodd" clipRule="evenodd" fill="#FF0000" d="M49.004,34.217c1.838,0,3.329-1.49,3.329-3.329
                                                c0-1.838-1.491-3.328-3.329-3.328c-1.839,0-3.329,1.49-3.329,3.328C45.675,32.727,47.165,34.217,49.004,34.217z M36.49,38.195
                                                c-1.839,0-3.329,1.491-3.329,3.329c0,1.839,1.49,3.329,3.329,3.329c1.838,0,3.329-1.49,3.329-3.329
                                                C39.819,39.687,38.329,38.195,36.49,38.195z M30.233,38.597c1.838,0,3.329-1.49,3.329-3.329c0-1.838-1.49-3.329-3.329-3.329
                                                c-1.839,0-3.329,1.491-3.329,3.329C26.904,37.106,28.395,38.597,30.233,38.597z M43.028,39.68c1.839,0,3.329-1.49,3.329-3.329
                                                s-1.49-3.329-3.329-3.329c-1.838,0-3.329,1.49-3.329,3.329S41.19,39.68,43.028,39.68z M30.515,44.284
                                                c-1.838,0-3.329,1.49-3.329,3.329c0,1.838,1.491,3.328,3.329,3.328s3.329-1.49,3.329-3.328
                                                C33.844,45.774,32.354,44.284,30.515,44.284z M45.957,42.607c0,1.839,1.49,3.329,3.328,3.329c1.839,0,3.329-1.49,3.329-3.329
                                                s-1.49-3.329-3.329-3.329C47.447,39.278,45.957,40.769,45.957,42.607z M49.004,50.709c-1.839,0-3.329,1.491-3.329,3.329
                                                c0,1.839,1.49,3.329,3.329,3.329c1.838,0,3.329-1.49,3.329-3.329C52.333,52.2,50.842,50.709,49.004,50.709z M42.261,17.248
                                                c-13.535,0-24.508,10.972-24.508,24.507s10.973,24.507,24.508,24.507S66.768,55.29,66.768,41.755S55.796,17.248,42.261,17.248z
                                                 M42.261,64.271c-12.436,0-22.517-10.081-22.517-22.517s10.081-22.518,22.517-22.518c12.436,0,22.517,10.082,22.517,22.518
                                                S54.696,64.271,42.261,64.271z M36.772,50.541c-1.838,0-3.329,1.49-3.329,3.329c0,1.838,1.491,3.328,3.329,3.328
                                                s3.329-1.49,3.329-3.328C40.101,52.031,38.61,50.541,36.772,50.541z M55.261,33.816c-1.839,0-3.329,1.49-3.329,3.328
                                                c0,1.839,1.49,3.329,3.329,3.329c1.838,0,3.329-1.49,3.329-3.329C58.59,35.307,57.099,33.816,55.261,33.816z M42.259,0.67
                                                c-22.691,0-41.086,18.395-41.086,41.086s18.395,41.087,41.086,41.087c22.692,0,41.087-18.396,41.087-41.087
                                                S64.951,0.67,42.259,0.67z M42.26,79.506c-20.849,0-37.75-16.901-37.75-37.75s16.901-37.75,37.75-37.75
                                                c20.849,0,37.75,16.901,37.75,37.75S63.108,79.506,42.26,79.506z M42.747,44.452c-1.839,0-3.329,1.491-3.329,3.329
                                                c0,1.839,1.49,3.329,3.329,3.329c1.838,0,3.329-1.49,3.329-3.329C46.076,45.943,44.585,44.452,42.747,44.452z M55.542,45.535
                                                c-1.838,0-3.328,1.49-3.328,3.329s1.49,3.329,3.328,3.329c1.839,0,3.329-1.49,3.329-3.329S57.381,45.535,55.542,45.535z
                                                 M36.772,33.423c1.838,0,3.329-1.49,3.329-3.329s-1.49-3.329-3.329-3.329s-3.329,1.49-3.329,3.329S34.934,33.423,36.772,33.423z"
                                                />
                                        </g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    </svg>
                                </div>
                                CABLE
                            </Link>
                        </li>
                        <li className={this.props.routing.location.pathname === "/CableLength" ? 'current' : (this.props.order.cable_length !== null ? 'active' : '')}>
                            <Link to={this.props.order.cable_type !== null ? "/CableLength" : '#'}>
                                <div className="svg-container">
                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                         width="84px" height="84px" viewBox="0 0 84 84" enableBackground="new 0 0 84 84" xmlSpace="preserve">
                                    <g>
                                        <circle fill="none" cx="42.078" cy="41.756" r="41.086"/>
                                    </g>
                                    <g>
                                        <g>
                                            <path fillRule="evenodd" clipRule="evenodd" fill="#FF0000" d="M42.259,0.67c-22.691,0-41.086,18.395-41.086,41.086
                                                s18.395,41.087,41.086,41.087s41.087-18.396,41.087-41.087S64.95,0.67,42.259,0.67z M42.26,79.506
                                                c-20.85,0-37.75-16.901-37.75-37.75s16.9-37.75,37.75-37.75c20.849,0,37.75,16.901,37.75,37.75S63.108,79.506,42.26,79.506z
                                                 M62.605,33.738v4.448H50.043v8.29h12.563v4.447L74,42.331L62.605,33.738z M21.426,33.763l-11.395,8.593l11.395,8.594v-4.448
                                                h12.562v-8.29H21.426V33.763z"/>
                                        </g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    </svg>
                                </div>
                                LENGTH
                            </Link>
                        </li>
                        <li className={this.props.routing.location.pathname === "/PackagingType" ? 'current' : (this.props.order.packaging_type !== null ? 'active' : '')}>
                            <Link to={this.props.order.cable_length !== null ? "/PackagingType" : '#'}>
                                <div className="svg-container">
                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                         width="84px" height="84px" viewBox="0 0 84 84" enableBackground="new 0 0 84 84" xmlSpace="preserve">
                                    <path fillRule="evenodd" clipRule="evenodd" fill="#FF0000" d="M42.259,82.843c-22.691,0-41.086-18.396-41.086-41.087
                                        S19.567,0.67,42.259,0.67s41.087,18.395,41.087,41.086S64.95,82.843,42.259,82.843z M42.26,4.006
                                        c-20.849,0-37.75,16.901-37.75,37.75s16.901,37.75,37.75,37.75s37.75-16.901,37.75-37.75S63.108,4.006,42.26,4.006z M42.368,71.107
                                        c-16.42,0-29.73-13.311-29.73-29.73s13.311-29.73,29.73-29.73S72.1,24.957,72.1,41.377S58.788,71.107,42.368,71.107z M56.95,19.684
                                        l-7.978,13.818c-0.722-0.594-1.527-1.086-2.395-1.465l7.975-13.813c-3.634-1.932-7.779-3.026-12.185-3.026
                                        c-4.324,0-8.395,1.063-11.98,2.93l8.031,13.91c-0.864,0.379-1.669,0.87-2.389,1.462l-8.056-13.954
                                        c-6.804,4.532-11.353,12.183-11.613,20.913h15.991c-0.027,0.303-0.047,0.608-0.047,0.918c0,0.677,0.069,1.337,0.195,1.977H16.428
                                        c0.676,8.41,5.34,15.691,12.099,19.949l7.928-13.731c0.751,0.555,1.578,1.008,2.466,1.341l-7.935,13.743
                                        c3.439,1.679,7.296,2.638,11.383,2.638c4.17,0,8.103-0.991,11.595-2.733l-7.88-13.648c0.886-0.333,1.711-0.784,2.46-1.338
                                        l7.856,13.608c6.657-4.274,11.241-11.497,11.91-19.828H52.499c0.126-0.64,0.195-1.3,0.195-1.977c0-0.31-0.02-0.615-0.047-0.918
                                        h15.729C68.117,31.812,63.646,24.231,56.95,19.684z M42.368,49.271c-4.359,0-7.893-3.534-7.893-7.894s3.533-7.893,7.893-7.893
                                        s7.894,3.533,7.894,7.893S46.728,49.271,42.368,49.271z M42.368,39.403c-1.09,0-1.973,0.884-1.973,1.974s0.883,1.974,1.973,1.974
                                        s1.974-0.884,1.974-1.974S43.458,39.403,42.368,39.403z"/>
                                    <path fill="none" stroke="#FF0000" strokeMiterlimit="10" d="M44.128,43.13c0.149-0.104,0.297-0.235,0.418-0.383
                                        c0.121-0.147,0.233-0.32,0.314-0.501c0.082-0.182,0.146-0.386,0.178-0.592s0.038-0.427,0.015-0.643
                                        c-0.025-0.216-0.079-0.439-0.162-0.649c-0.084-0.21-0.199-0.419-0.341-0.605c-0.142-0.187-0.313-0.365-0.507-0.513
                                        c-0.192-0.149-0.412-0.278-0.646-0.374c-0.232-0.096-0.487-0.166-0.746-0.198s-0.531-0.033-0.797,0.006
                                        c-0.267,0.038-0.538,0.111-0.793,0.222c-0.255,0.11-0.505,0.257-0.729,0.435c-0.224,0.179-0.433,0.392-0.607,0.63
                                        c-0.175,0.238-0.325,0.506-0.434,0.789c-0.11,0.284-0.186,0.59-0.218,0.901c-0.032,0.312-0.025,0.635,0.026,0.952
                                        c0.052,0.318,0.146,0.637,0.282,0.937c0.136,0.301,0.314,0.592,0.53,0.854c0.215,0.261,0.469,0.501,0.753,0.701
                                        c0.284,0.202,0.599,0.371,0.933,0.493c0.334,0.124,0.692,0.207,1.055,0.238c0.364,0.033,0.739,0.02,1.106-0.046
                                        c0.368-0.064,0.735-0.178,1.081-0.341c0.347-0.162,0.678-0.372,0.977-0.625c0.298-0.252,0.569-0.548,0.797-0.876
                                        c0.228-0.329,0.416-0.693,0.553-1.077c0.136-0.385,0.226-0.794,0.259-1.21c0.032-0.416,0.012-0.843-0.066-1.261
                                        c-0.079-0.418-0.212-0.833-0.4-1.224c-0.188-0.392-0.431-0.765-0.72-1.1c-0.29-0.335-0.626-0.639-1.001-0.892
                                        c-0.374-0.253-0.786-0.462-1.221-0.612c-0.436-0.15-0.896-0.247-1.364-0.279c-0.468-0.032-0.946-0.005-1.415,0.087
                                        s-0.932,0.245-1.369,0.46c-0.437,0.214-0.851,0.487-1.223,0.814c-0.373,0.326-0.707,0.705-0.986,1.124
                                        c-0.28,0.419-0.508,0.879-0.672,1.365c-0.164,0.486-0.267,0.998-0.299,1.518s0.001,1.05,0.107,1.57
                                        c0.106,0.519,0.279,1.029,0.52,1.512c0.241,0.481,0.546,0.938,0.909,1.347s0.783,0.776,1.248,1.082
                                        c0.464,0.306,0.973,0.554,1.509,0.731c0.536,0.177,1.1,0.287,1.672,0.319c0.572,0.032,1.154-0.009,1.725-0.128
                                        c0.568-0.119,1.128-0.312,1.655-0.579c0.526-0.268,1.024-0.604,1.47-1.003c0.446-0.401,0.845-0.862,1.176-1.372
                                        c0.332-0.51,0.602-1.066,0.792-1.652c0.191-0.587,0.308-1.202,0.34-1.827c0.033-0.625-0.015-1.258-0.147-1.878
                                        s-0.347-1.227-0.639-1.8c-0.294-0.572-0.662-1.111-1.099-1.594c-0.438-0.483-0.94-0.913-1.495-1.271
                                        c-0.556-0.358-1.16-0.647-1.797-0.851s-1.305-0.328-1.981-0.36c-0.677-0.032-1.362,0.021-2.033,0.168
                                        c-0.671,0.146-1.327,0.379-1.944,0.699c-0.617,0.319-1.197,0.719-1.718,1.193c-0.52,0.475-0.981,1.019-1.365,1.618
                                        c-0.384,0.6-0.693,1.253-0.911,1.941c-0.218,0.687-0.348,1.406-0.38,2.135c-0.032,0.729,0.028,1.467,0.188,2.187
                                        c0.16,0.722,0.413,1.426,0.758,2.089c0.345,0.662,0.777,1.284,1.289,1.841s1.096,1.05,1.742,1.46
                                        c0.645,0.41,1.346,0.739,2.084,0.971c0.737,0.231,1.508,0.368,2.29,0.401c0.781,0.032,1.571-0.036,2.341-0.21
                                        c0.771-0.173,1.524-0.446,2.232-0.817c0.707-0.371,1.37-0.835,1.964-1.384c0.594-0.547,1.119-1.174,1.556-1.864
                                        c0.436-0.69,0.785-1.439,1.029-2.229c0.245-0.788,0.389-1.611,0.421-2.444c0.033-0.833-0.042-1.674-0.229-2.496
                                        s-0.48-1.622-0.877-2.375c-0.397-0.753-0.894-1.458-1.479-2.088c-0.585-0.63-1.253-1.188-1.988-1.65
                                        c-0.736-0.462-1.534-0.831-2.373-1.089c-0.839-0.259-1.713-0.409-2.598-0.442c-0.886-0.033-1.778,0.049-2.65,0.249
                                        c-0.872,0.201-1.721,0.514-2.52,0.938c-0.798,0.423-1.543,0.951-2.211,1.573c-0.668,0.622-1.257,1.331-1.745,2.112
                                        s-0.877,1.627-1.149,2.516s-0.429,1.815-0.462,2.753s0.056,1.882,0.27,2.805s0.547,1.82,0.997,2.663
                                        c0.449,0.844,1.009,1.631,1.667,2.335c0.659,0.704,1.41,1.326,2.236,1.84c0.826,0.515,1.721,0.923,2.66,1.209
                                        c0.94,0.285,1.918,0.449,2.908,0.481s1.986-0.063,2.959-0.29c0.973-0.227,1.918-0.58,2.808-1.057
                                        c0.887-0.475,1.717-1.066,2.458-1.762c0.74-0.695,1.394-1.487,1.934-2.358c0.54-0.872,0.97-1.814,1.27-2.804
                                        c0.297-0.99,0.469-2.021,0.502-3.063c0.032-1.042-0.07-2.09-0.312-3.113c-0.24-1.023-0.614-2.017-1.115-2.951
                                        c-0.502-0.934-1.125-1.805-1.857-2.582c-0.732-0.778-1.566-1.463-2.483-2.029c-0.916-0.567-1.905-1.016-2.946-1.328
                                        c-1.04-0.313-2.122-0.49-3.216-0.523c-1.094-0.032-2.194,0.077-3.268,0.331s-2.116,0.647-3.095,1.175
                                        c-0.979,0.527-1.891,1.183-2.706,1.952c-0.815,0.77-1.531,1.645-2.125,2.606c-0.592,0.962-1.061,2.001-1.386,3.091
                                        c-0.326,1.091-0.511,2.224-0.544,3.371c-0.032,1.146,0.084,2.298,0.352,3.423c0.268,1.124,0.681,2.214,1.235,3.237
                                        c0.554,1.025,1.241,1.979,2.047,2.83c0.806,0.853,1.723,1.6,2.73,2.219c1.006,0.619,2.094,1.107,3.235,1.447
                                        c1.141,0.339,2.326,0.53,3.525,0.563c1.199,0.032,2.402-0.091,3.577-0.371c1.174-0.282,2.313-0.715,3.383-1.295
                                        c1.069-0.58,2.063-1.299,2.953-2.142c0.888-0.844,1.669-1.802,2.313-2.854s1.153-2.188,1.506-3.379
                                        c0.353-1.191,0.552-2.429,0.584-3.68c0.032-1.251-0.098-2.506-0.392-3.731c-0.295-1.225-0.748-2.412-1.354-3.526
                                        c-0.605-1.115-1.356-2.15-2.236-3.076c-0.879-0.926-1.88-1.738-2.978-2.408c-1.097-0.671-2.28-1.2-3.522-1.566
                                        c-1.241-0.366-2.531-0.571-3.833-0.604c-1.303-0.033-2.61,0.104-3.885,0.412c-1.275,0.308-2.511,0.782-3.67,1.414
                                        c-1.159,0.632-2.237,1.415-3.2,2.331c-0.962,0.917-1.807,1.958-2.503,3.101s-1.246,2.375-1.625,3.667
                                        c-0.38,1.292-0.592,2.633-0.625,3.988c-0.032,1.354,0.111,2.714,0.433,4.04c0.322,1.325,0.815,2.609,1.473,3.813
                                        c0.658,1.205,1.472,2.324,2.426,3.323c0.954,1.001,2.037,1.876,3.224,2.599s2.468,1.291,3.811,1.685
                                        c1.343,0.394,2.736,0.612,4.143,0.645c1.407,0.033,2.818-0.117,4.194-0.452s2.709-0.849,3.958-1.533
                                        c1.251-0.684,2.41-1.529,3.446-2.52c1.037-0.99,1.944-2.116,2.693-3.348c0.749-1.233,1.338-2.563,1.744-3.955
                                        c0.407-1.393,0.633-2.838,0.666-4.297c0.032-1.459-0.124-2.922-0.473-4.348c-0.349-1.426-0.883-2.807-1.593-4.102
                                        c-0.71-1.295-1.588-2.498-2.615-3.571c-1.028-1.073-2.193-2.013-3.472-2.788c-1.277-0.775-2.655-1.384-4.098-1.805
                                        c-1.443-0.42-2.94-0.653-4.452-0.685c-1.511-0.033-3.026,0.131-4.503,0.494c-1.477,0.362-2.905,0.916-4.246,1.652
                                        s-2.584,1.646-3.694,2.71c-1.11,1.063-2.081,2.271-2.882,3.594c-0.801,1.323-1.431,2.749-1.864,4.242
                                        c-0.434,1.493-0.673,3.042-0.706,4.605s0.138,3.131,0.514,4.657c0.375,1.527,0.949,3.004,1.711,4.39
                                        c0.762,1.385,1.705,2.671,2.805,3.817c1.101,1.147,2.35,2.15,3.718,2.978c1.368,0.826,2.843,1.476,4.386,1.924
                                        c1.544,0.446,3.145,0.693,4.76,0.726S45.886,60,47.464,59.61c1.577-0.39,3.103-0.983,4.533-1.771c1.431-0.789,2.757-1.763,3.94-2.9
                                        c1.185-1.138,2.22-2.429,3.072-3.842c0.854-1.413,1.522-2.936,1.983-4.529c0.461-1.595,0.714-3.247,0.746-4.915
                                        c0.033-1.668-0.151-3.338-0.555-4.965c-0.402-1.628-1.016-3.203-1.83-4.678c-0.814-1.476-1.82-2.844-2.995-4.065
                                        c-1.175-1.22-2.507-2.287-3.965-3.167c-1.458-0.879-3.029-1.568-4.673-2.042c-1.646-0.475-3.35-0.734-5.07-0.767
                                        c-1.72-0.033-3.442,0.158-5.12,0.574c-1.678,0.416-3.301,1.05-4.821,1.891s-2.931,1.877-4.188,3.089
                                        c-1.258,1.212-2.356,2.586-3.262,4.089c-0.906,1.503-1.615,3.123-2.103,4.818c-0.487,1.694-0.754,3.451-0.787,5.223
                                        c-0.032,1.772,0.165,3.546,0.595,5.275c0.429,1.728,1.083,3.398,1.95,4.965c0.867,1.565,1.936,3.017,3.185,4.312
                                        c1.249,1.294,2.664,2.425,4.212,3.355c1.549,0.932,3.216,1.662,4.961,2.162c1.745,0.502,3.553,0.775,5.377,0.809
                                        c1.825,0.032,3.65-0.173,5.429-0.615c1.779-0.443,3.498-1.117,5.109-2.011c1.61-0.892,3.103-1.994,4.435-3.278
                                        c1.332-1.285,2.493-2.742,3.451-4.336c0.957-1.594,1.707-3.31,2.222-5.105s0.795-3.655,0.827-5.532
                                        c0.033-1.876-0.179-3.754-0.635-5.583c-0.457-1.829-1.15-3.596-2.069-5.252s-2.052-3.19-3.374-4.559
                                        c-1.322-1.368-2.82-2.562-4.459-3.546c-1.64-0.983-3.403-1.752-5.25-2.281c-1.846-0.528-3.757-0.816-5.686-0.848
                                        c-1.929-0.033-3.858,0.186-5.738,0.656c-1.879,0.47-3.695,1.184-5.396,2.129c-1.701,0.945-3.277,2.109-4.682,3.469
                                        c-1.405,1.359-2.632,2.898-3.641,4.583c-1.01,1.684-1.799,3.497-2.341,5.393c-0.542,1.896-0.835,3.86-0.868,5.841
                                        c-0.032,1.981,0.193,3.963,0.676,5.892c0.483,1.931,1.217,3.795,2.188,5.541c0.971,1.747,2.167,3.363,3.563,4.807
                                        c1.396,1.441,2.978,2.699,4.706,3.735c1.729,1.035,3.59,1.845,5.537,2.399c1.947,0.556,3.962,0.856,5.995,0.889
                                        c2.033,0.033,4.067-0.199,6.046-0.696c1.98-0.498,3.893-1.251,5.686-2.248c1.79-0.997,3.45-2.226,4.929-3.658
                                        s2.769-3.055,3.83-4.829c1.063-1.775,1.891-3.684,2.459-5.682c0.569-1.996,0.877-4.064,0.91-6.149"/>
                                    <path fill="none" stroke="#FF0000" strokeMiterlimit="10" d="M42.254,40.964"/>
                                    <path fill="none" stroke="#FF0000" strokeMiterlimit="10" d="M42.652,41.057"/>
                                    <path fill="none" stroke="#FF0000" strokeMiterlimit="10" d="M42.851,41.309"/>
                                    <path fill="none" stroke="#FF0000" strokeMiterlimit="10" d="M42.824,41.554"/>
                                    <path fill="none" stroke="#FF0000" strokeMiterlimit="10" d="M42.652,41.653"/>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    </svg>
                                </div>
                                PACKAGING
                            </Link>
                        </li>
                        <li className={this.props.routing.location.pathname === "/OptionalAttributes" ? 'current' : (this.props.order.product !== null ? 'active' : '')}>
                            <Link to={this.props.order.packaging_type !== null ? "/OptionalAttributes" : '#'}>
                                <div className="svg-container">
                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                         width="84px" height="84px" viewBox="0 0 84 84" enableBackground="new 0 0 84 84" xmlSpace="preserve">
                                    <g>
                                        <circle fill="none" cx="42.078" cy="41.756" r="41.086"/>
                                    </g>
                                    <g>
                                        <g>
                                            <path fillRule="evenodd" clipRule="evenodd" fill="#FF0000" d="M42.259,0.67c-22.691,0-41.086,18.395-41.086,41.086
                                                s18.395,41.087,41.086,41.087s41.087-18.396,41.087-41.087S64.95,0.67,42.259,0.67z M42.26,79.506
                                                c-20.849,0-37.75-16.901-37.75-37.75s16.901-37.75,37.75-37.75s37.75,16.901,37.75,37.75S63.108,79.506,42.26,79.506z M46.5,19.5
                                                h-8v19h-19v8h19v19h8v-19h19v-8h-19V19.5z"/>
                                        </g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    </svg>
                                </div>
                               OPTIONS
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        );

    }

}

const mapStateToProps = state => ({
    routing: state.routing,
    order: state.order
})

const mapDispatchToProps = dispatch => bindActionCreators({
}, dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Navigation)


// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/containers/app/navigation.js